import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Criterials from '../../process/general/criterials';
import {Table} from 'react-bootstrap';
import ModalUnits from './modal';
import WaitingModal from '../../generics/WaitingModal';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../config');
var report = require('../../generics/report_head');

class UnitsWarehouse extends Component{
	constructor(props){
		super(props);

		this.getData = this.getData.bind(this);
		this.openModal = this.openModal.bind(this);
		this.validateInput = this.validateInput.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.viewDetails = this.viewDetails.bind(this);
		this.setTable = this.setTable.bind(this);

		this.state = {
			components: [],
			filterText:"",
			show_table:false,
			details:[],
			columns:[
				{title: 'Componente'},
				{title: 'No. Unidad'},
				{title: 'No. Componente'},
				{title: 'Estatus'},
				{title: 'Fecha Donación'},
				{title: 'Fecha Caducidad'},
				{title: 'Grupo & RH'},
				{title: 'Fenotipo'},
			],
			filename:'Unidades de Almacén',
			date_hour:"",
			medical:""
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				date_hour:aux[0]+' '+hours,
			});
		});
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	getData(result){
		this.$el1 = $('#table1');
		this.$el1.DataTable().destroy();

		var header = ['A+','A-','B+','B-','AB+','AB-','O+','O-'];

		var components = [];
		result.map((r)=>{
			var obj = {component_type:r.component_type , blood_component_name: r.blood_component_name, groups:[]}

			header.map((h, j)=>{
				var i = r.groups.findIndex(obj => obj.group_rh === h);

				if(i !== -1){
					obj.groups.push(r.groups[i]);
				}else{
					obj.groups.push('')
				}
				
			})

			obj.blood_component_id = r.blood_component_id;
			obj.total = r.total;
			obj.status = r.status;
			components.push(obj);
		})

		this.setState({
			components: components//result
		});

		this.$el1.DataTable({
			dom: 'Bfrtip',
			buttons: [{
            	extend: 'pdf',
            	title: this.state.filename,
            	orientation: 'portrait',
            	customize: (doc) => { 
            		doc.content.unshift({
						image: this.props.header_document,
						alignment:'center',
						width:this.props.w_head
					});
					doc.content.splice(2, 0, {text: 'Fecha de emisión '+this.state.date_hour, margin:[10,0,0,10] });
					doc.content[3].table.body.map((b, i)=>{
            			b.map((t, j)=>{
            				if(j>1){
        						b[j].alignment = 'right' 
            				}
            			})
            		})

					doc.content[3].table.widths=["30%","20%","5%","5%","5%","5%","5%","5%","5%","5%","10%"];

					if(this.state.show_table){
						var headers = []
						this.state.columns.map((c)=>{
							headers.push({text:c.title, style:'tableHeader'})
						})
						this.state.details.unshift(headers)
						
						doc.content[3].pageBreak = 'after'
						doc.content[3].pageOrientation ='landscape';
						
						doc.content.push({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						
						doc.content.push({
							text:'Detalles Unidades Almacén', 
							margin:[0,0,0,12],
							style:'title',
						})

						doc.content.splice(6, 0, {text: this.state.date_hour, margin:[10,0,0,10] });
                		doc.content.push({
                			table: {                				
                				headerRows: 1,
                				body:this.state.details
                			},
                			layout:'noBorders'

                		})

                		doc.content[7].table.widths=["20%", "10%","10%","10%","10%","10%","10%","20%"];
					}
						
        			doc.styles.tableHeader.fontSize = 7;
            		doc.defaultStyle.fontSize = 7;
            		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};

            	} 
        	}],
        	columnDefs: [{
		        targets: [2,3,4,5,6,7,8,9,10],
		        className: 'dt-head-right'
    		}],
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sLoadingRecords":"Cargando...",
			},
			paging:false,
			responsive:false,
			searching: false,
			ordering:false,
			info:false,
			createdRow: (row, data, dataIndex)=>{
				data.map((d, i)=>{
					if(i > 1){
						$('td:eq('+i+')', row).attr('class', 'td-number');
					}
				});				
			}
		});
	}

	openModal(e){
		console.log(this.criterials)
		this.modal_units.handleShow(
			e.target.id,
			e.target.getAttribute('group'), 
			e.target.getAttribute('rh'),
			e.target.getAttribute('group_rh'),
			e.target.getAttribute('process_name'),
			e.target.getAttribute('unit_status'),
			this.criterials.state.health_facilities_id
		);
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});
	}

	validateInput(e) {
	    const re = /^[-+]?$/;

	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined)
    			form.elements[index + 1].focus();
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	filter(item){
		var res = true;

		var text = item.component_type+' '+item.blood_component_name;

		if(text !== null){
			if(text.toString().indexOf(this.state.filterText.toUpperCase()) !== -1 ){
				res = true;
			}else{
				res = false;
			}
		}

		return res;
	}

	viewDetails(e){
		if(e.target.checked){
			this.criterials.setState({details: true});
			this.setState({show_table:true});
			this.setTable();

			var health = this.criterials.state.health_facilities_id;
			
			setTimeout(()=>{
				this.props.waiting.handleShow('Cargando...');
				fetch(Config.default.apiGateway.URL+'units/storage_all_units?health_facilities_id='+
					health+'&component_type='+this.criterials.state.blood_component_id+
					'&status='+this.criterials.state.status,{
					method:'get',
					headers: new Headers({
						'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
						'Accept'		: 'application/json',
						'content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						var list = [];
						response.map((r, i)=>{
							var obj = [];
							obj.push(
								r.component,
								r.unit_number,
								r.component_number,
								r.status,
								r.donation_date !== null ? moment(r.donation_date).format('DD/MM/YYYY') : '',
								moment(r.caducidad).format('DD/MM/YYYY HH:mm'),
								r.group_rh
							)

							var phen = '';
							r.phenotypes.map((f)=>{
								phen += f.phenotype1+' '+f.result+', '
							});

							obj.push(phen);

							list.push(obj);
						})


						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);

						this.setState({
							details: list,
						});
					}
				})
			}, 500);
				
		}else{
			this.criterials.setState({details: false});
			this.setState({show_table:false});
		}
	}

	setTable(){

		this.$el = $(this.el);
		
		this.$el.DataTable({		
			data: this.state.details,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sLoadingRecords":"Cargando...",
			},
			paging:false,
			responsive:false,
			searching: false,
			scrollY:"22em",
			scrollX: false,
			autoWidth: false,
			ordering:false,
			info:false,
		});
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.warehouse.MAIN')} ->
						{t('sidebar.nav.warehouse.unitsWarehouse')}
					</h5>
				</div>
				<Help 
					{...this.props}
		            menu={"help_storage"} 
		            submenu={"help_units_storage"}  />
				<form noValidate>
					<div className="col-xs-12">
						<fieldset>
							<legend style={{fontSize:"1.5em", marginBottom:"5px"}}>Búsqueda</legend>
							
							<div className="col-xs-12">
								<Criterials validate={this.validateInput} sendData={this.getData} 
									details={this.viewDetails}
									{...this.props} onRef={ref => (this.criterials = ref)} />
							</div>
							<div className="col-xs-12 form-group">
								<div className="col-xs-12 col-sm-3" style={{paddingLeft:'13px'}}>
									<input type="text" className="form-control" placeholder="Filtro..." name="filterText" 
										value={this.state.filterText} onChange={this.handleChange} />
								</div>
							</div>			
						</fieldset>
					</div>
					<hr style={{width:"90%"}} />
					<div className="col-xs-12">
						<Table responsive hover id="table1">
							<thead>
								<tr>
									<th>TIPO COMPONENTE</th>
									<th>COMPONENTE SANGUÍNEO</th>
									<th>A+</th>
									<th>A-</th>
									<th>B+</th>
									<th>B-</th>
									<th>AB+</th>
									<th>AB-</th>
									<th>O+</th>
									<th>O-</th>								
									<th>TOTAL</th>
								</tr>
							</thead>
							<tbody>
								{this.state.components.map((c, i)=>(
									this.filter(c) === true ?
										<tr key={i}>
											<td>{c.component_type}</td>
											<td>{c.blood_component_name}</td>
											{c.groups.map((g, j)=>(
												g === "" ?
													<td key={j}></td>
												:<td key={j}>
													<span id={c.blood_component_id} 
														group_rh={g.group_rh} group={g.group} rh={g.rh} unit_status={c.status}
														style={{color:g.color, fontWeight:"bold", cursor:"pointer"}}
														process_name={c.blood_component_name} 
														onClick={this.openModal}
														>
														{g.amount}
													</span>
												</td>
											))}
											<td>{c.total}</td>
										</tr>
									: null
								))}
							</tbody>
						</Table>
					</div>

					{this.state.show_table ?
						<div className="col-sm-12 form-group">
							<fieldset>
								<legend>Detalles</legend>
								<div className="col-xs-12">
									<div className="table-responsive">
										<table style={{fontSize:"11px"}}  id="table_details" width="100%" ref={el => this.el = el}>
										</table>
									</div>
								</div>
								{/*}
								<Table responsive hover>
									<thead>
										<tr>
											<th>Familia de Componente</th>
											<th>Número Unidad</th>
											<th>Estatus</th>
											<th>Fecha Donación</th>
											<th>Fecha Caducidad</th>
											<th>Grupo & RH</th>
											<th>Fenotipo</th>
										</tr>
									</thead>
								</Table>*/}
							</fieldset>
						</div>
						
					:null }
				</form>
				<ModalUnits 
					waiting={this.waiting_modal} {...this.props} 
					onRef={ref => (this.modal_units = ref)} 
				/>
				<WaitingModal  {...this.props} onRef={ref => (this.waiting_modal = ref)} />
			</div>
		)
	}
}

export default translate('translations')(UnitsWarehouse);